export default __webpack_public_path__ + "static/media/pr_c_14.97bb3537.jpg";